import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

import type {
  ListingsAPIAndFilter,
  ListingsAPIOrFilter,
} from '../../common/types/ListingsAPIFilter';
import type { ListingsAPIFacetSpec } from '../types/ListingsAPIFacetSpec';
import type { ListingsAPIRequestBody } from '../types/ListingsAPIRequestBody';

export class ListingsRequestBuilder {
  private request: ListingsAPIRequestBody = {
    currencyCode: 'GBP',
    facetSpecs: [],
    filter: {},
  };

  currency(code: CurrencyCode): this {
    this.request.currencyCode = code;
    return this;
  }

  offset(offset: number): this {
    this.request.offset = offset;
    return this;
  }

  pageSize(size: number): this {
    this.request.pageSize = size;
    return this;
  }

  searchTerm(term: string): this {
    this.request.searchTerm = term;
    return this;
  }

  facetSpecs(facetSpecs: ListingsAPIFacetSpec[]): this {
    if (this.request.facetSpecs.length) {
      throw new Error('facet specs already set on the request');
    }

    this.request.facetSpecs = facetSpecs;
    return this;
  }

  filter(filter: ListingsAPIAndFilter | ListingsAPIOrFilter): this {
    if (this.request.filter && Object.keys(this.request.filter).length > 0) {
      throw new Error('a filter is already set on the request');
    }
    this.request.filter = filter;
    return this;
  }

  pageCategories(pageCategories: string[]): this {
    this.request.pageCategories = pageCategories;
    return this;
  }

  sortBy(key: string, descending: boolean): this {
    this.request.sortBy = key ? `${key}${descending ? ' desc' : ''}` : '';
    return this;
  }

  build(): ListingsAPIRequestBody {
    return { ...this.request };
  }
}
